module.exports = __webpack_public_path__ + "media/src/images/reports-128-2727b94e1f4c29c573099c617ccf32c0.png";